import React, { useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import PricePlans from '../../components/ToggleTabs';
import bannerImage from '../../images/landing/hvac/firebnr.png';
import logo1 from '../../images/landing/hvac/logo1.png';
import logo2 from '../../images/landing/hvac/logo2.png';
import logo3 from '../../images/landing/hvac/logo3.png';
import serviceImage from '../../images/landing/hvac/hvac2.png';
import Googleimg from '../../images/landing/hvac/logo4.png';
import backgroundimg from '../../images/landing/hvac/image1.png';
import Insightimage1 from '../../images/landing/hvac/image6.png';
import Insightimage2 from '../../images/landing/hvac/image7.png';
import Insightimage3 from '../../images/landing/hvac/image8.png';
import FaqrightImage from '../../images/landing/hvac/Frame.png';
import Group from '../../images/landing/hvac/Group.png';
import work1 from '../../images/landing/hvac/1.png';
import tes2 from '../../images/landing/hvac/image12.png';
import work2 from '../../images/landing/hvac/2.png';
import work3 from '../../images/landing/hvac/3.png';
import work4 from '../../images/landing/hvac/4.png';
import ReviewBackgroundImage from '../../images/landing/hvac/Group1.png';
import Review from '../../images/landing/hvac/test1.png';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import style from '../../pages/industries/MobileView.css';

import { 
  AccountTree,
  TrendingUp,
  PersonAdd,
  Assignment,
  Engineering,
  ReceiptLong,
  Payments,
  Analytics,
  Transform,
  AutoGraph,
  Timeline,
  Loop,
  CheckCircle, 
  ArrowForward,
  Cancel,
  NextArrow,
  PrevArrow
  
} from '@mui/icons-material';

const PageContainer = styled.div`
  min-height: 100vh;
  background: #fff;
  overflow-x:hidden;


  h2 {
    text-align: left;
    font-size: 40px;
    margin-bottom: 2rem;
    line-height: 48px;
    font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif !important;
    color: #000;
    font-weight: 600;

     @media (max-width: 768px) {
      font-size: 24px;
      line-height: 30px;
    }
  }
  span{
    color: #4F46E5;
  }

  p {
    font-size: 16px;
    font-weight: 300;
    margin-bottom: 2rem;
    font-family: 'Poppins', sans-serif;
    color: #5B5B5B;
  }
  
`;

const Hero = styled.div`
  background: url(${bannerImage}) no-repeat top center;
  background-size: cover;
  padding: 16rem 2rem 8rem 2rem;
  margin-top: -80px;
  color: white;
  text-align: center;
  position: relative;
  overflow: hidden;
  height: 747px;

   @media (max-width: 768px) {
      padding: 13rem 1rem 8rem 1rem;
    }
      
     @media (min-width: 769px) and (max-width: 1024px)  {
      padding: 13rem 1rem 8rem 1rem;
    }


    h1 {
    max-width:1400px;
    margin: 0 auto;
    padding: 1rem 4rem;
    text-align: left;
    font-size: 45px;
    font-weight: 600;
    line-height: 55px;
    position: relative;
    z-index: 2;
    font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;

     @media (max-width: 768px) {
      font-size: 23px;
      line-height: 35px;
      padding: 0rem;
    }
  }

  p {
    max-width: 1400px;
    margin: 0 auto;
    font-size: 16px;
    font-weight: 300 !important;
    line-height: 25px;
    position: relative;
    z-index: 2;
    font-family: 'Poppins', sans-serif;
    padding-right: 47em;
    text-align: left;
    padding-left: 4em;
    letter-spacing: 1px;
    color: #fff;

     @media (max-width: 768px) {
      padding: 1rem 0;
    }
     @media (min-width: 769px) and (max-width: 1024px)  {
      padding: 0rem 0rem 0rem 2rem;
    }
  }
  .hero-btn{
    margin: 0 auto;
    max-width: 1400px;
    padding: 1rem 4rem;
    text-align: left;

     @media (max-width: 768px) {
      display: flex;
      padding: 0px;
      flex-direction: column;
      gap: 10px;
    }
    }
  button{
    font-size: 16px;
    font-weight: 600 !important;
    line-height: 25px;
    font-family: 'Poppins', sans-serif;
    background: #4F46E5;
    border-radius: 16px;
    padding: 15px 15px;
    color: #fff;
    border:2px solid #4F46E5;

    @media (max-width: 700px) {
      padding: 10px;
      font-size: 13px;
      line-height: 20px;
    }
  }
  .secondary-button {
  font-size: 16px;
  font-weight: 600;
  line-height: 25px;
  font-family: 'Poppins', sans-serif;
  background: transparent;
  border-radius: 16px;
  padding: 15px 24px;
  color: #fff;
  border: 2px solid #fff;
  margin-left: 20px;
  cursor: pointer;
  transition: background 0.3s ease, color 0.3s ease;

  @media (max-width: 700px) {
      padding: 10px;
      font-size: 13px;
      line-height: 20px;
      margin-left: 0px;
    }

  &:hover {
    background: #fff;
    color: #000;
  }

  @media (max-width: 768px) {
      padding: 10px;
      font-size: 13px;
      line-height: 20px;
  }
    }
}
`;
const CarouselWrapper = styled.div`
  overflow: hidden;
  width: 100%;

  
`;
const LogoCarousel = styled.div`
  padding: 4rem 0rem;
  overflow: hidden;

  h2 {
    text-align: center;
    font-size: 40px;
    margin-bottom: 2rem;
    line-height: 48px;
    font-family: font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif !important;
    color: #000;
    font-weight: 600;

    @media (max-width: 768px) {
      padding: 10px;
      font-size: 24px;
      line-height: 30px;
    }
  }
  span{
    color: #4F46E5;
  }
`;



const CarouselTrack = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  width: fit-content;
  animation: scroll 25s linear infinite;
  padding: 50px;

  img {
    height: 50px;
    margin-right: 4rem; 
    opacity: 0.8;
    transition: all 0.3s ease;

    &:hover {
      filter: none;
      opacity: 1;
    }
  }

  @keyframes scroll {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-50%);
    }
  }
`;

const Servicesection = styled.div`
  overflow: hidden;
  max-width: 1400px;
  padding: 1rem 1rem 1rem 2rem;
  display: flex;
  gap: 5em;
  margin: 0 auto;
  align-item: center;
  padding-bottom: 10em;

  img{
  width: 100%;
  }

  
  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 2em;
    padding: 1rem 1rem 0em 1rem;
  }
`;

const Imagecontainer = styled.div`
  flex: 0 0 40%;
  width: 40% !important;


  @media screen and (max-width: 768px) {
    flex: 0 0 100%;
  width: 100% !important;
  }
`;

const Textcontainer = styled.div`
  text-align: left;
  flex: 0 0 50%;
  width: 50%;


  @media screen and (max-width: 768px) {
    flex: 0 0 100%;
  width: 100%;
  }

   @media (min-width: 769px) and (max-width: 1024px)  {
    flex: 0 0 100%;
  width: 100%;
  }

  h2 {
    text-align: left !important;
    font-size: 40px;
    margin-bottom: 2rem;
    line-height: 48px;
    font-family: font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif !important;
    color: #000;
    font-weight: 600;

    @media (max-width: 768px) {
      padding: 0px;
      font-size: 24px;
      line-height: 35px;
    }
  }
  h3 {
    text-align: left;
    font-size: 30px;
    margin-bottom: 2rem;
    line-height: 38px;
    font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif !important;
    color: #000;
    font-weight: 600;
  }
  span{
    color: #4F46E5;
  }

  p {
    font-size: 16px;
    font-weight: 300;
    margin-bottom: 2rem;
    font-family: 'Poppins', sans-serif;
    color: #5B5B5B;
  }

  .counters {
    display: flex;
    gap: 0rem;
    font-size: 20px;
    font-family: 'Poppins', sans-serif;
    background: #F4F2FF;
    padding: 40px;
    border-radius: 16px;
    margin: 3em 0 0 0;
    text-align: center;
    align-items: anchor-center;
    justify-content: center;
    width: 100% !important;
    margin-top: 0px;
    margin-left: 0 !important;
    margin-right: 0px;


    @media (max-width: 768px) {
      padding: 10px;
      margin-left: 0px !important;
      margin-right: 0px !important;
      width: 91vw;
      margin-top: 30px !important;
  }
  @media (min-width: 769px) and (max-width: 1024px) {
        margin-left: -48% !important;
        margin-right: 10px;
        width: 91vw;
        margin-top: 188px !important;
    }
      }

    img{
      width: 80%;
      height:100%;
    }

    .counters{
      font-weight: 500;
      display : flex;
      margin-top: 30px;

      @media (max-width: 768px) {
      flex: 0 0 100% !important;
      width: 100% !important;

      }

    div{
      flex: 0 0 33%;
      width: 33%;

      @media screen and (max-width: 768px) {
        flex: 0 0 33%;
        width: 33%;
        margin-top: 0px !important;
        margin-left: 0px !important;
       }

      } 
      
      strong {
        font-size: 28px;
        display: block;
        color: #000000;
        font-weight: 600;

        @media (max-width: 768px) {
        font-size: 22px;
        line-height: 25px;
        }
      }

      span#plussign{
        font-size: 28px;
        font-weight: 600;
        color: #4F46E5;

        @media (max-width: 768px) {
        font-size: 22px;
        line-height: 25px;
        }
      }

      span {
        font-size: 15px;
        color: #5B5B5B;

        @media (max-width: 768px) {
        font-size: 13px;
        line-height: 18px;
      }
      }
    }
    div:nth-child(2) {
      border-left: 1px solid #E2E2E2;
      border-right: 1px solid #E2E2E2;
    }
  }

 
    button{
    font-size: 16px;
    font-weight: 600 !important;
    line-height: 25px;
    font-family: 'Poppins', sans-serif;
    background: #4F46E5;
    border-radius: 16px;
    padding: 15px 15px;
    color: #fff;
    border:2px solid #4F46E5;

    @media (max-width: 768px) {
    font-size: 15px;
    padding: 15px 3px;
    }
  }
  .secondary-button {
  font-size: 16px;
  font-weight: 600;
  line-height: 25px;
  font-family: 'Poppins', sans-serif;
  background: transparent;
  border-radius: 16px;
  padding: 15px 4px;
  color: #000;
  border: 2px solid #fff;
  margin-left: 20px;
  text-decoration: underline;
  cursor: pointer;
  transition: background 0.3s ease, color 0.3s ease;

  &:hover {
    background: #fff;
    color: #000;
  }
  
}
}


`;

const Schedule = styled.div`
 background: url(${backgroundimg}) no-repeat top center;
  background-size: cover;
  overflow: hidden;
  max-width: 1329px;
  padding: 1rem 4rem;
  margin: 73px auto;
  align-items: center;
  height: 492px;
  justify-content: center;
  border-radius: 24px;
  display: flex;


  @media screen and (max-width: 768px) {
  max-width: 100%;
  width: 100%;
  height: 100%;
  border-radius: 0px;
  padding: 0rem;
  }
  
   @media (min-width: 769px) and (max-width: 1024px)  {
  border-radius: 0px;
  max-width: 100%;
  width: 100%;
  }
;
`;

const Maincontainer = styled.div`
    display: flex;
    gap: 5em;
    position: absolute;
    width: 1219px;


    @media screen and (max-width: 768px) {
    flex-wrap: wrap;
    position: relative;
    padding: 3em 1em !important;
    width: 100%;
    margin-bottom: -9% !important;
    }

     @media (min-width: 769px) and (max-width: 1024px)  {
     width: 90%;
     }

  .sche-txtbx {
    flex: 0 0 50%;
    width: 50%;
    margin-top: 9em;


    @media screen and (max-width: 768px) {
    flex: 0 0 100%;
    width: 100%;
    margin-top: 0em;
    }

    h2{      
      text-align: left !important;
    }
  }
  .sche-frmbx {
    width: 50%;
    flex: 0 0 50%;

 
    @media screen and (max-width: 768px) {
    width: 100%;
    flex: 0 0 100%;
    margin-bottom: -16%;
    }
  }

    .sche-txtbxs {
    flex: 0 0 100%;
    width: 100%;
    margin-top: 0em;
    text-align: center;

    h2{
      text-align: center;
    }
  }
  button{
    font-size: 16px;
    font-weight: 600 !important;
    line-height: 25px;
    font-family: 'Poppins', sans-serif;
    background: #4F46E5;
    border-radius: 16px;
    padding: 15px 15px;
    color: #fff;
    border:2px solid #4F46E5;

    @media (max-width: 768px) {
    font-size: 15px;
    padding: 15px 3px;
    }
  }
  .secondary-button {
  font-size: 16px;
  font-weight: 600;
  line-height: 25px;
  font-family: 'Poppins', sans-serif;
  background: transparent;
  border-radius: 16px;
  padding: 15px 4px;
  color: #ff;
  border: 0px solid #fff;
  margin-left: 20px;
  text-decoration: underline;
  cursor: pointer;
  transition: background 0.3s ease, color 0.3s ease;
  
}
h2, p{
  color: #ffffff;
}


  form {
    width: 480px;
    background: #fff;
    border-radius: 24px;
    box-shadow: 0px -6px 11px #25334b4a;
    text-align: center;
    padding: 50px 20px;

    @media (max-width: 708px) {
        width: 100% !important;
        }

    @media (min-width: 769px) and (max-width: 1024px)  {
      width: 380px;
    }

    p, h3{
      color: #000000;
    }
      h3{
      color: #000000;
      font-size: 30px;
    }

    .frst-frm {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    padding: 10px;

      .frs-nm, .lst-nm{
          width: 50%;
          flex: 0 0 50%;
      }
    input, select {
              width: 100%;
              background: #F9F9F9;
              border: 0px;
              height: 56px;
              padding: 15px;
              border-radius: 8px;
        }
    }
  .full-bx{
    width: 100%;
    display: flex;
    padding: 10px 0px;

    select {
      width: 100%;
      background: #F9F9F9;
      border: 0px;
      height: 56px;
      padding: 15px;
      border-radius: 8px;
    }
    button {
      width: 100%;
    }
  }
  }
`;

const Faqbox = styled.div`
  padding: 6rem 6rem 2rem 6rem;
    background-color: #F4F2FF;
    position: relative;
    width: 100%;

 
    @media screen and (max-width: 768px) {
    padding: 5rem 0rem;
    }

     @media (min-width: 769px) and (max-width: 1024px)  {
      padding: 5rem 1rem;
    }

    h2{
    text-align: center;
    }
`;

const FaqContent = styled.div`
  display: flex;
  gap: 2rem;
  justify-content: space-between;
  padding: 1rem 0rem;

 
    @media screen and (max-width: 768px) {
    flex-wrap: wrap;
    padding: 2rem 0;
    }

     @media (min-width: 769px) and (max-width: 1024px)  {
      padding: 5rem 2rem 5rem 0;
    }
`;

const FaqItems = styled.div`
  flex: 0 0 50%;
  min-width: 50%;


    @media screen and (max-width: 768px) {
    flex: unset;
    min-width: auto;
    }
  
`;

const AccordionItem = styled.div`
  cursor: pointer;
  padding-bottom: 20px !important;
`;



const Question = styled.div`
  padding: 1rem 1.5rem;
  background-color: ${({ active }) => (active ? '#E8EDFF' : 'transparent')};
  color: #000; /* Always black text */
  cursor: pointer;
  border-radius: 24px 24px 0 0 !important;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 30px 0 30px !important;

  @media (max-width: 768px) {
    font-size: 19px !important;
    line-height: 25px !important;
    border-radius: 24px !impoerant;
  }

   @media (min-width: 769px) and (max-width: 1024px)  {
    border-radius: 0px !impoerant;
    }

  span {
    font-size: 24px;
    font-weight: bold;
    color: ${({ active }) => (active ? '#fff' : '#000')}; /* Icon color: blue when active, black when inactive */
    transition: color 0.3s;

    @media (max-width: 768px) {
        font-size: 19px;
        line-height: 25px;
        }
  }
`;


const Answer = styled.div`
  margin-top: 1rem;
  font-size: 16px;
  color: #555;
  padding: 0px 30px 30px 30px;
  border-radius: 0 0 24px 24px;

    @media (max-width: 768px) {
    padding: 0px 30px 0px 30px;
    border-radius: 0px;
  }

  ul{
    padding: 20px 20px 0px 20px; 
    font-size: 16px;
    font-weight: 300;
    margin-bottom: 2rem;
    font-family: 'Poppins', sans-serif; 
    border-radius: 0px !Important;
  }
`;

const RightsideImage = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;

  img {
    max-width: 100%;
    height: 586px;
    border-radius: 12px;
    box-shadow: 0 10px 20px rgba(0,0,0,0.1);



    @media screen and (max-width: 768px) {
    display: none;
    }
  }

  
`;

const DesktopImageWrapper = styled.div`
  display: block;
  flex: 0 0 50%;

  img {
    max-width: 100%;
    height: auto;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const MobileImageWrapper = styled.div`
  display: none;
  text-align: center;
  padding-top: 1rem;

  @media (max-width: 768px) {
    display: block;
    padding: 0px;
    background: #4f46e5;
    border-radius: 0 0 24px 24px;
    padding: 30px;
  }

  img {
    max-width: 100%;
    height: auto;
  }
`;

const Schedules = styled.div`
 background: url(${backgroundimg}) no-repeat top center;
  background-size: cover;
  overflow: hidden;
  max-width: 1329px;
  padding: 2rem 4rem;
  margin: 150px auto;
  align-items: center;
  height: 390px;
  justify-content: center;
  border-radius: 24px;
  display: flex;

  @media (max-width: 768px) {
    max-width: 100%;
    height: 100%;
    border-radius: 0px;
    padding: 2rem 0rem;
    margin: 90px auto;
  }
     @media (min-width: 769px) and (max-width: 1024px)  {
    border-radius: 0px;
    padding: 2rem 0rem;
    margin: 90px auto;
    }

  
;
`;

const WhyHvac = styled.div`
  overflow: hidden;
  max-width: 1400px;
  padding: 1rem 2rem 7rem 2rem;
  margin: 0 auto;

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 0rem 0rem;
  }

   @media (min-width: 769px) and (max-width: 1024px)  {
      padding: 5rem 0rem;
    }

`;

const InnrHvac = styled.div`
  overflow: hidden;
  max-width: 1400px;
  padding: 1rem 1rem 1rem 2rem;

   @media (max-width: 768px) {
    max-width: 100%;
    padding: 0px;
  }

  

  .hvac-props {
    display: flex;
    gap: 20px;

    @media (max-width: 1024px) {
      flex-direction: column;
      }

    h2{
    text-align: left !important;

     @media (min-width: 769px) and (max-width: 1024px)  {
     text-align: center !important;
    }

    }

    @media (max-width: 768px) {
    flex-wrap: wrap;
    }

    h2{
    font-size:40px;
    font-weight: 500;

     @media (max-width: 768px) {
    font-size: 24px !important;
    line-height: 30px !important;
  }
    }

    .hvacprops.propsbx1 {
    flex: 0 0 33%;
    width: 33%;

    @media (max-width: 768px) {
    flex: 0 0 100%;
    width: 100%;
    padding: 30px 20px !important;
    }

     @media (min-width: 769px) and (max-width: 1024px)  {
    flex: 0 0 100%;
    width: 100%;
    padding: 30px 6em;
    text-align: center !important;
    }
    }

    .hvacprops.propsbx2 {
    display: flex;
    padding-left: 60px;

    @media (max-width: 768px) {
      padding: 0px;
      flex-wrap: wrap;
      
    }
      @media (max-width: 1024px) {
      padding: 0px;
    }

    }
    .grn-propsbx {
    background: #E7FFE5;
    padding: 50px 30px;
    border-top-left-radius: 16px;
    border-bottom-left-radius: 16px;
    flex: 0 0 50%;

    @media (max-width: 768px) {
    flex: 0 0 100%;
    width: 100%;
    border-radius: 0px;
    padding: 30px 20px;
    }

  }
    .red-propsbx{
    background: #F5ECEC;
    padding: 50px 30px;
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px;
    flex: 0 0 50%;

    @media (max-width: 768px) {
    flex: 0 0 100%;
    width: 100%;
    border-radius: 0px;
    padding: 30px 20px;
    }
    }

    ul li {
    list-style: none;
    font-size: 15px;
    font-weight: 300;
    font-family: 'Poppins', sans-serif;
    color: #5B5B5B;
    line-height: 20px;
    }

    h3 {
    text-align: center;
    padding: 0 0 30px 0;
    font-size: 24px;
    }

    li {
    display: flex;
    padding: 10px 0;
    align-items: flex-start;
    }
    button{
    font-size: 16px;
    font-weight: 600 !important;
    line-height: 25px;
    font-family: 'Poppins', sans-serif;
    background: #4F46E5;
    border-radius: 16px;
    padding: 15px 15px;
    color: #fff;
    border:2px solid #4F46E5;

    @media (max-width: 768px) {
    font-size: 15px;
    padding: 15px 3px;
    }
  }
  }
`;

const Business = styled.div`
  overflow: hidden;
  text-align: center;
  padding-top: 90px;

   @media (max-width: 768px) {
   padding: 3em 1em 3em 1em;
  }

  button{
    font-size: 16px;
    font-weight: 600 !important;
    line-height: 25px;
    font-family: 'Poppins', sans-serif;
    background: #4F46E5;
    border-radius: 16px;
    padding: 15px 15px;
    color: #fff;
    border:2px solid #4F46E5;

    @media (max-width: 768px) {
    font-size: 15px;
    padding: 15px 3px;
    }
  }

  h2{
  text-align: center;
  }

`;
const MainbussinessImage = styled.div`
  background: url(${Group}) no-repeat top center;
  background-size: cover;
  height: 551px;
  margin-top: -9%;

  @media (max-width: 768px) {
   background-size: contain;
    margin-top: 0;
    height: 130px;
    margin-left: 0px;
    
    }
  
`;


const TestimonialSection = styled.div`
  background: #F4F4F4;
  padding: 5em 7em;
  position: relative;
  z-index: 1;

  @media (max-width: 768px) {
    padding: 5em 1em;
    }

    @media (max-width: 1024px) {
      padding: 5rem 1rem;
    }

  h2{
  text-align: center;
  }

  .reviw-div {
    display: flex;
    padding: 3em 0 0 0;
    position: relative;
    z-index: 2;

    @media (max-width: 768px) {
    flex-wrap: wrap !important;
    }

    @media (min-width: 769px) and (max-width: 1024px)  {
      align-items: anchor-center;
    }

    .review-imag {
     flex: 0 0 35%;
     width: 35%;
     position: relative;
      z-index: 3;

      @media (max-width: 768px) {
        flex: 0 0 70%;
        width: 70%;
        margin: 0 auto;
      }

      @media (min-width: 769px) and (max-width: 1024px)  {
      flex: 0 0 50%;
        width: 50%;
        margin: 0 auto;
    }
    
     img {
      width: 100%;
      }
    }
  }
  .service-btn{
    text-align: center;
    padding: 5em 0 0 0;
    display: flex;
    width: 100% !important;
    justify-content: center;

    @media (max-width: 768px) {
      width: 100% !important;
      justify-content: unset;
  }
  

    button{
      font-size: 16px;
      font-weight: 600 !important;
      line-height: 25px;
      font-family: 'Poppins', sans-serif;
      background: #4F46E5;
      border-radius: 16px;
      padding: 15px 15px;
      color: #fff;
      border:2px solid #4F46E5;

      @media (max-width: 768px) {
    font-size: 15px;
    padding: 15px 3px;
    }
    }
    .secondary-button {
    font-size: 16px;
    font-weight: 600;
    line-height: 25px;
    font-family: 'Poppins', sans-serif;
    background: transparent;
    border-radius: 16px;
    padding: 15px 4px;
    color: #000;
    border: 0px solid #fff;
    margin-left: 20px;
    text-decoration: underline;
    cursor: pointer;
    transition: background 0.3s ease, color 0.3s ease;
    
  }
  }
`;


const TestimonialWrapper = styled.div`
 flex: 0 0 65%;
 width: 65%;
 position: relative;
  z-index: 4;
  padding: 8em 0 0 0;

  @media (max-width: 768px) {
    flex: 0 0 100%;
    width: 100%;
    padding: 0px !important;
    }

     @media (min-width: 769px) and (max-width: 1024px)  {
      flex: 0 0 50%;
    width: 50%;
    padding: 0px !important;
    }
  
`;

const Ineertestimonails = styled.div`
 

  .slick-list{
  background: url(${ReviewBackgroundImage}) no-repeat bottom center;
    background-size: cover;
    overflow: hidden;
    padding: 3em;
    height: fit-content;
    border-radius: 20px;
    margin-left: -4em;
    margin-bottom: 4em;

    @media (max-width: 768px) {
    background: url(${ReviewBackgroundImage}) no-repeat bottom right;
    background-size: cover;
    margin-left: 0em;
    margin-bottom: 0em;
    margin-top: -3em;
    }
  }
    .slick-prev:before {
    content: '←';
    position: absolute;
    top: -6em;
    left: 17em;
    font-size: 40px;
    color: #000;

    @media (max-width: 768px) {
    display: none;
    }

     @media (min-width: 769px) and (max-width: 1024px)  {
      left: 7em;
    }
}
    .slick-next:before {
    position: absolute;
    top: -6em;
    right: 3em;
    font-size: 40px;
    color: #000;

    @media (max-width: 768px) {
    display: none;
    }
}
  
`;
const TestimonialCard = styled.div`
  width: 90% !important;

   @media (max-width: 768px) {
    width: 90% !important;
    margin-left: -2em;
  }

  blockquote{
  font-size: 16px;
  font-weight: 300;
  margin-bottom: 1rem;
  font-family: 'Poppins', sans-serif;
  color: #fff;
  }

  p{
  color:#fff;
  }

  h4{
  font-size: 24px;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  color: #fff;
  }
  span{
  color: #7C7C7C;
  }
 
  
  
`;

const PricePlan = styled.div`
  background: #F4F2FF;
  padding: 5em 3em;
  text-align: center;
  margin: 0 auto;

  .tab {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 5em 0;
    gap: 20px;
    background: #fff;
    width: 11%;
    margin: 3em auto;
    padding: 10px 15px;
    border-radius: 50px;

    .monthly {
    background: #4F46E5;
    color: #fff;
    border-radius: 55px;
    padding: 11px 20px;
}
}

  h2{
  text-align: center;
  }

  .inr-plantab
 {
    display: flex;
    align-items: self-start;
    justify-content: flex-start;
    gap: 20px;

    .pln-bx {
    background: #fff;
    text-align: left;
    padding: 2em;
    border-radius: 24px;

    li {
    list-style: none;
    display: flex;
    padding: 10px 0;
    }

    button{
    font-size: 16px;
    font-weight: 600 !important;
    line-height: 25px;
    font-family: 'Poppins', sans-serif;
    background: #4F46E5;
    border-radius: 16px;
    padding: 15px 15px;
    color: #fff;
    border:2px solid #4F46E5;

    @media (max-width: 768px) {
    font-size: 15px;
    padding: 15px 3px;
    }
    }
    
    }

    .pln-bx.scnd-bx {
    background: linear-gradient(180deg, #c8c1f4 0%, #4338ca99 50%, #e096e5 100%) !important;
    color: #fff !important;
    margin-top: -1%;
    box-shadow: 0px 4px 8px #00000047;

    .popuplar {
    background: #c8c1f4;
    width: 42%;
    float: right;
    padding: 6px;
    border-radius: 24px;
    text-align: center;
    }

    span, p, strong {
    color: #fff !important;
    }

    strong{
    font-weight: 600;
    }
  }
    }
`;

const InsightSection = styled.div`
  padding: 5em 7em;

  @media (max-width: 768px) {
    padding: 3em 1em;
    }

     @media (min-width: 769px) and (max-width: 1024px)  {
      padding: 5rem 3rem;
    }
 
  h2{
    text-align: center;
  }

  p{
  text-align: center;
  
  }
`;

const Mobilebox = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    padding: 0px;
    }

    h3, p, small{
     text-align: left;
    }
     
    p{
      margin: 10px 0 5px 0px !important;
      font-weight: 600 !important;
    }
`;



const Ineerinsightbox = styled.div`
  display: flex;
  padding: 3em 0;
  gap: 20px;

  @media (max-width: 768px) {
    display: none;
    }

  div {
    flex: 0 0 33%;

    @media (max-width: 768px) {
    flex: 0 0 100%;
    }

    h3, p, small{
    font-family: 'Poppins', sans-serif;
    text-align: left !important;
   

    @media (max-width: 768px) {
     text-align: left !important;
    }
    }

    p{
      margin: 10px 0 5px 0px !important;
      font-weight: 600 !important;
    }

    h3{
      font-weight: 700 !important;
    }
}
  
`;

const FAQsection = styled.div`
  padding: 5em 7em;
  text-align: center;

  @media (max-width: 768px) {
    padding: 0em 1em;
    }

     @media (min-width: 769px) and (max-width: 1024px)  {
      padding: 5rem 1rem;
    }

  h2{
    text-align: center;
  }

  p{
    text-align: center;
    padding: 0 10em;

    @media (max-width: 768px) {
    padding: 0em;
    }
  }
  

  button{
    font-size: 16px;
    font-weight: 600 !important;
    line-height: 25px;
    font-family: 'Poppins', sans-serif;
    background: #4F46E5;
    border-radius: 16px;
    padding: 15px 15px;
    color: #fff;
    border:2px solid #4F46E5;
    text-align: center;

    @media (max-width: 768px) {
    margin-bottom: 2em;
    }
  }
  
`;

const FaqItem = styled.div`
  text-align: left;
  padding: 5em 7em 0 7em;

  @media (max-width: 768px) {
    padding: 0em;
    }
  
`;

const AccordionItems = styled.div`
  border-bottom: 1px solid #E2E2E2;
  cursor: pointer;
  padding-bottom: 22px;
  
`;

const Topfooter = styled.div`
  background: url(${backgroundimg}) no-repeat top center;
  background-size: cover;
  overflow: hidden;
  max-width: 1329px;
  padding: 2rem 4rem;
  margin: 60px auto;
  align-items: center;
  height: 295px;
  justify-content: center;
  border-radius: 24px;
  display: flex;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    border-radius: 0px;
    height: auto;
    max-width: 100%;
    padding: 2rem 0rem;
    }

     @media (min-width: 769px) and (max-width: 1024px)  {
    border-radius: 0px;
    height: auto;
    max-width: 100%;
    padding: 2rem 0rem;
    }
  
`;

const FooterMaincontainer = styled.div`
  padding: 0 1em;
  width: 100%;

  .top-footer {
    display: flex;
    align-items: anchor-center;

    @media (max-width: 768px) {
    flex-wrap: wrap;
    }

  .frst-lftsc {
    flex: 0 0 50%;
    width: 50%;

    @media (max-width: 768px) {
    flex: 0 0 100%;
    width: 100%;
    }

    h2{
    color:#fff;
    padding-right: 5em;


    @media (max-width: 768px) {
    padding-right: 0em;
    text-align: left !important;
    }

    @media (min-width: 769px) and (max-width: 1024px)  {
      text-align: left !important;
      font-size: 35px;
    }
    }
  
  }
    button{
    font-size: 16px;
    font-weight: 600 !important;
    line-height: 25px;
    font-family: 'Poppins', sans-serif;
    background: #4F46E5;
    border-radius: 16px;
    padding: 15px 15px;
    color: #fff;
    border:2px solid #4F46E5;

    @media (max-width: 768px) {
    font-size: 15px;
    padding: 15px 3px;
    }
  }
  .secondary-button {
  font-size: 16px;
  font-weight: 600;
  line-height: 25px;
  font-family: 'Poppins', sans-serif;
  background: transparent;
  border-radius: 16px;
  padding: 15px 4px;
  color: #ff;
  border: 0px solid #fff;
  margin-left: 20px;
  text-decoration: underline;
  cursor: pointer;
  transition: background 0.3s ease, color 0.3s ease;
  
}
  p{
  color:#fff;
  font-weight: 500;
  }
  }
  
`;


 



const services = [
  {
    colortitle: "Top-Rated Fire Safety ",
    title: "Inspection Software for Field Teams",
    description: "Designed for fire protection contractors, inspection companies, and compliance managers, ServTrackr streamlines inspections, reporting, and equipment maintenance, all in one easy-to-use platform.", 
    counterno1: "24",
    counterdesc1: "Projects Completed",
    counterno2: "10",
    counterdec2: "Years Experience",
    counter: "K+"
  }
];


 

const faqs = [
  {
    question: "Fire Inspection Scheduling Made Simple ",
    answer: "<ul> <li>Schedule tests & checks instantly</li> <li>Real-time tech availability</li> <li>NFPA-compliant recurring reminders</li> <li>Plan inspections with ease</li> <li>Stay on top of every site</li> </ul>"
  },
  {
    question: "Faster Field Response with Fire Protection Dispatch Software ",
    answer: "Send the right techs to the right sites with live GPS tracking. Our fire technician dispatch app optimizes routes, improves response time, and lets you manage last-minute calls without chaos. "
  },
  {
    question: " Complete Visibility Across Your Fire Safety Operations ",
    answer: "See every inspection, report, and technician update as it happens. With our fire system maintenance software, your office and field teams stay in sync, no guesswork, no delays"
  },
  {
    question: "Faster Payments with Mobile Invoicing",
    answer: "Create invoices onsite or online using our mobile invoicing for fire safety pros. Accept payments instantly, track all billing records, and reduce admin time while keeping cash flow steady. "
  },
  {
    question: " Client & Equipment Records at Your Fingertips ",
    answer: "Access service logs, asset history, and compliance files in seconds. Our fire safety business CRM keeps everything organized, from extinguishers and alarms to site visits and inspection tags."
  },
  {
    question: "Quote and Bill Fire Protection Services in Minutes ",
    answer: "Use our built-in fire protection estimating software to quote jobs faster and convert them into service reports or invoices instantly, fully aligned with NFPA guidelines. "
  }
];


 
 

const footerfaqs = [
  {
    question: "What is fire protection service software? ",
    answer: " It's a platform that helps fire safety professionals schedule inspections, generate reports, manage compliance, and track technician performance in real time. "
  },
  {
    question: "Can I automate NFPA inspection reminders? ",
    answer: "  Yes, ServTrackr supports automated inspection reminders for all recurring tasks  from fire extinguishers to suppression systems.  "
  },
  {
    question: "Can I manage extinguisher and alarm inventories?  ",
    answer: "  Yes, our fire extinguisher inventory management tools let you track equipment, scan barcodes, and view service history in one click. "
  },
  {
    question: "Is it good for multi-location compliance tracking? ",
    answer: "  Yes, ServTrackr is perfect for companies with multiple clients or buildings. Track inspection history, issue reports, and manage compliance at scale.",
  },
  {
    question: "Can I generate NFPA reports digitally? ",
    answer: " Definitely. Our software generates professional, NFPA-compliant inspection reports you can send instantly to clients or regulators. "
  },
  {
    question: "Is ServTrackr available in the UK? ",

    answer: " Yes! Our platform is used by fire safety businesses across both the USA and UK, including support for local compliance guidelines and inspections.",
  }

];

const testimonials = [
  {
    name: "Jordan M., ",
    role: " Director @ FlameShield Compliance Group",
    quote: "Tried It, Loved It, Never Going Back ",
    description:
    "ServTrackr helped us ditch paper reports and cut inspection time in half. Now our techs handle jobs faster, and we generate NFPA-compliant reports right from the field.",
  },
   {
    name: "Jordan M., ",
    role: " Director @ FlameShield Compliance Group",
    quote: "Tried It, Loved It, Never Going Back ",
    description:
    "ServTrackr helped us ditch paper reports and cut inspection time in half. Now our techs handle jobs faster, and we generate NFPA-compliant reports right from the field.",
  },
  {
    name: "Jordan M., ",
    role: " Director @ FlameShield Compliance Group",
    quote: "Tried It, Loved It, Never Going Back ",
    description:
    "ServTrackr helped us ditch paper reports and cut inspection time in half. Now our techs handle jobs faster, and we generate NFPA-compliant reports right from the field.",
  }
];

const Insightdata = [
  {
    Insighttitle: "Top Tools for Fire Safety Inspectors",
    Insightdesc: "Explore essential field tools that help fire protection techs streamline reporting and ....",
    Insightdate: "April 15, 2025 ",
    InsightImage: Insightimage1,
  },
  {
    Insighttitle: "Better Scheduling for Fire System Mai....",
    Insightdesc: "Discover how fire inspection scheduling software helps teams stay compliant and re..",
    Insightdate: "April 11, 2025  ",
    InsightImage: Insightimage2,
  },
  {
    Insighttitle: "Smart Invoicing for Fire Protection Serv...",
    Insightdesc: "Simplify billing with digital tools that send invoices on the spot and reduce admin stress.",
    Insightdate: "April 29, 2025",
    InsightImage: Insightimage3,
  },
];

function FireProtection() {
const [activeIndex, setActiveIndex] = React.useState(null);
    
    const toggleAccordion = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
    };
    
    
    const [isYearly, setIsYearly] = useState(false);
    
    const togglePlan = () => {
      setIsYearly(!isYearly);
    };
    
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 4000,
      };

  return (
  <PageContainer>
      <Hero>
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Fire Protection Service <br></br> Software That Outperforms<br></br> the Rest
        </motion.h1>
        <p>
         Automate fire inspections, NFPA compliance reports, alarm testing, and technician dispatch with ServTrackr, your all-in-one fire protection service software. Save time, reduce manual errors, and stay fully compliant across every site.
        </p>
        <div class="hero-btn">
          <Link to="#">
            <button>Start Free Trial <ArrowForward style={{ marginLeft: '8px', verticalAlign: 'middle' }} /></button>
        </Link>
        <Link to="#">
            <button class="secondary-button">Watch 60-Second Demo <ArrowForward style={{ marginLeft: '8px', verticalAlign: 'middle' }} /></button>
        </Link>

        </div>
      </Hero>

      <LogoCarousel>
        <h2><span>Trusted by 5,000+ </span>Fire Safety Contractors and<br></br> Compliance Teamsacross the USA & UK</h2>
        <CarouselWrapper>
          <CarouselTrack>
            {/* Duplicate logos to loop perfectly */}
            {[logo1, logo2, logo3, logo1, logo2, logo3, logo1, logo2, logo3].map((logo, i) => (
              <img src={logo} alt={`Client ${i}`} key={i} />
            ))}
            {[logo1, logo2, logo3, logo1, logo2, logo3, logo1, logo2, logo3].map((logo, i) => (
              <img src={logo} alt={`Client ${i + 6}`} key={i + 6} />
            ))}
          </CarouselTrack>
        </CarouselWrapper>
      </LogoCarousel>

      <Servicesection>
        {services.map((feature, index) => (
          <React.Fragment key={index}>
            <Imagecontainer>
              <img src={serviceImage} alt={feature.title} />
            </Imagecontainer>

            <Textcontainer>
              <h2><span>{feature.colortitle}</span>{feature.title}</h2>
              <p>{feature.description}</p>
              <div class="service-btn" style={{ flex: "0 0 100%", width: "100%" }}>
                <Link to="#">
                  <button>Start Free Trial <ArrowForward style={{ marginLeft: '8px', verticalAlign: 'middle' }} /></button>
              </Link>
              <Link to="#">
                  <button class="secondary-button">Book a Demo </button>
              </Link>

              </div>
              <div className="counters">
                <div>
                  <img src={work1} alt="google" />
                </div>
                <div>
                   <img src={work2} alt="google" />
                  {/* <strong>{feature.counterno1}<span id="plussign">{feature.counter}</span></strong>
                  <span>{feature.counterdesc1}</span> */}
                </div>
                <div>
                   <img src={work3} alt="google" />
                  {/* <strong>{feature.counterno2}<span id="plussign">{feature.counter}</span></strong>
                  <span>{feature.counterdec2}</span> */}
                </div>
                <div>
                   <img src={work4} alt="google" />
                  {/* <strong>{feature.counterno2}<span id="plussign">{feature.counter}</span></strong>
                  <span>{feature.counterdec2}</span> */}
                </div>
              </div>
            </Textcontainer>

            
          </React.Fragment>
        ))}
        
      </Servicesection>


      <Schedule>

        <Maincontainer>
          <div class="sche-txtbx">
            
              <h2>Ready to Modernize Your Fire <br></br>Protection Operations?</h2>
              <p>
                Try ServTrackr free, no credit card needed. From digital inspection reports to real-time fire system tracking, our field service software for fire protection helps you save hours and stay audit-ready.
                </p>
               <div class="service-btn">
                <Link to="#">
                  <button>Start Free Trial <ArrowForward style={{ marginLeft: '8px', verticalAlign: 'middle' }} /></button>
              </Link>
              <Link to="#">
                  <button class="secondary-button">Book a Demo </button>
              </Link>

              </div>
          </div>
          <div class="sche-frmbx">
            <form>
              <h3>Schedule a <span>Demo</span></h3>   
              <p>See how ServTrackr can simplify your Fire Protection  business in just minutes. </p>
              <div class="frst-frm">
                <div class="frs-nm">
                <input type="text" name="first-name" placeholder="Enter First Name*" required />
                </div>
                <div class="lst-nm">
                <input type="text" name="last-name" placeholder="Enter Last Name*" required />
                </div>
              </div>
              <div class="frst-frm">
                <div class="frs-nm">
                  <input type="email" name="email" placeholder="Enter Email*" required />
                </div>
                <div class="lst-nm">
                <input type="tel" name="phone" placeholder="Enter Phone Number*" required />
                </div>
              </div>
              <div class="frst-frm">
                <div class="frs-nm">
                <input type="text" name="company" placeholder="Enter Companys Name*" required />
                </div>
                <div class="lst-nm">
                  <select name="businessType" required>
                    <option value="">Enter No of Employees*</option>
                    <option value="hvac">10-20</option>
                    <option value="plumbing">20-40</option>
                    <option value="electrical">40-80</option>
                  </select>
                </div>
              </div>
              <div class="full-bx">
              <select name="businessType" required>
                    <option value="">Select Your Industry* </option>
                    <option value="hvac">Option1</option>
                    <option value="plumbing">option2</option>
                    <option value="electrical">option3</option>
              </select>
              </div>
              <div class="full-bx">
              <select name="businessType" required>
                    <option value="">Select Your Region*</option>
                    <option value="hvac">India</option>
                    <option value="plumbing">USA</option>
                    <option value="electrical">UK</option>
              </select>
              </div>
               <div class="full-bx">
              <button type="submit">Submit <ArrowForward style={{ marginLeft: '8px', verticalAlign: 'middle' }} /></button>
              </div>
            </form>

          </div>
        </Maincontainer>
      </Schedule>

      <Faqbox>
  <h2>
     
    Fire Safety Software<span> That Solves <br></br>Real Problems</span>
  </h2>

  <FaqContent>
      <FaqItems>
        {faqs.map((item, index) => {
          const isActive = activeIndex === index;
          return (
            <AccordionItem key={index}>
              <Question
                onClick={() => toggleAccordion(index)}
                style={{
                  backgroundColor: isActive ? '#4F46E5' : 'transparent',
                  color: isActive ? '#fff' : '#000',
                  padding: '1rem',
                  cursor: 'pointer',
                  marginBottom: '10px',
                  transition: 'all 0.3s ease',
                  margin: '0px',
                  fontSize: '20px',
                  fontFamily: 'BlinkMacSystemFont, sans-serif',
                  fontWeight: '600',
                }}
              >
                {item.question}
               <span style={{ float: 'right', color: isActive ? '#fff' : '#000' }}>
               {isActive ? '-' : '+'}
                </span>
              </Question>

              {isActive && (
                <>
                  <Answer
                    dangerouslySetInnerHTML={{ __html: item.answer }}
                    style={{
                      backgroundColor: '#4F46E5',
                      padding: '10px 30px 30px 30px',
                      fontFamily: 'Poppins, sans-serif',
                      color: '#fff',
                      fontSize: '15px',
                      margin: '0px',
                    }}
                  />
                  <MobileImageWrapper>
                    <img src={FaqrightImage} alt="FAQ Illustration" />
                  </MobileImageWrapper>
                </>
              )}
            </AccordionItem>
          );
        })}
      </FaqItems>

      {/* Desktop image */}
      <DesktopImageWrapper>
        <img src={FaqrightImage} alt="FAQ Illustration" />
      </DesktopImageWrapper>
    </FaqContent>
  </Faqbox>



      <Schedules>
        <Maincontainer>
          <div class="sche-txtbxs">
             
              <h2>Protect What Matters Most with<br></br>Fire Safety Services!</h2>
              <p>Start Your 14-Day Free Trial — No Credit Card Required!</p>
               <div class="service-btn">
                <Link to="#">
                  <button>Start Free Trial <ArrowForward style={{ marginLeft: '8px', verticalAlign: 'middle' }} /></button>
              </Link>
              <Link to="#">
                  <button class="secondary-button">Book a Demo </button>
              </Link>

              </div>
          </div>
          </Maincontainer>
          </Schedules>


           


          <WhyHvac>
              <InnrHvac>
                <div class="hvac-props">
                  <div class="hvacprops propsbx1">
                    

                    <h2><span> We Lead the Way</span><br></br>  in Fire Protection Software</h2>
                    <p>
                        No fluff. Just powerful tools that help you manage fire protection services seamlessly. Try the smarter, simpler fire protection software.
                        </p>
                    <Link to="#">
                      <button>Start Free Trial <ArrowForward style={{ marginLeft: '8px', verticalAlign: 'middle' }} /></button>
                    </Link>
                  </div>
                  <div class="hvacprops propsbx2">
                    <div class="grn-propsbx">
                      <h3>ServTrackr</h3>
                      <ul>
                        <li><div class="icon-bx"><CheckCircle style={{ marginRight: '8px', verticalAlign: 'middle', color: '#0DBC00' }} /></div><div class="txt-icnbx">Works offline for remote sites.</div></li>
                        <li><CheckCircle style={{ marginRight: '8px', verticalAlign: 'middle', color: '#0DBC00' }} />Free 1-hour onboarding.</li>
                        <li><CheckCircle style={{ marginRight: '8px', verticalAlign: 'middle', color: '#0DBC00' }} />Transparent pricing starting at $49/month.</li>
                        <li><CheckCircle style={{ marginRight: '8px', verticalAlign: 'middle', color: '#0DBC00' }} />Includes inspections, scheduling, billing & compliance.</li>
                        <li><CheckCircle style={{ marginRight: '8px', verticalAlign: 'middle', color: '#0DBC00' }} />Built specifically for fire protection teams.</li>
                      </ul>
                    </div>
                    <div class="red-propsbx">
                      <h3>Other Tools </h3>
                      <ul>
                        <li><Cancel style={{ marginRight: '8px', verticalAlign: 'middle', color: '#D60000' }} />Requires full internet or Wi-Fi.</li>
                        <li><Cancel style={{ marginRight: '8px', verticalAlign: 'middle', color: '#D60000' }} />$299 setup fee..</li>
                        <li><Cancel style={{ marginRight: '8px', verticalAlign: 'middle', color: '#D60000' }} />‘Talk to Sales’ for pricing.</li>
                        <li><Cancel style={{ marginRight: '8px', verticalAlign: 'middle', color: '#D60000' }} />Multiple tools needed for compliance</li>
                        <li><Cancel style={{ marginRight: '8px', verticalAlign: 'middle', color: '#D60000' }} />Not designed for NFPA or fire inspection workflows.</li>
                      </ul>
                    </div>
                  </div>

                </div>
              </InnrHvac>
          </WhyHvac>

              <TestimonialSection>
            <h2>What Our <span>Clients Are Saying</span></h2>
            <div class="reviw-div">
              <div class="review-imag">
                <img src={tes2} />
              </div>
            <TestimonialWrapper>
              <Ineertestimonails>
              <Slider {...settings}>
                {testimonials.map((testimonial, index) => (
                  <TestimonialCard key={index}>
                    <blockquote>"{testimonial.quote}"</blockquote>
                    <p>{testimonial.description}</p>
                    <h4>{testimonial.name}</h4>
                    <span>{testimonial.role}</span>
                  </TestimonialCard>
                  
                ))}
                
              </Slider>
              </Ineertestimonails>
            </TestimonialWrapper>
            </div>
            <div class="service-btn">
                <Link to="#">
                  <button>Start Free Trial <ArrowForward style={{ marginLeft: '8px', verticalAlign: 'middle' }} /></button>
              </Link>
              <Link to="#">
                  <button class="secondary-button">Book a Demo </button>
              </Link>

              </div>
          </TestimonialSection>
         

          <Business>
            <div class="buss-bx">
                
            <h2><span>Powerful Integrations for</span> <br></br> Fire Safety Operations</h2>
            <p>ServTrackr syncs with QuickBooks, Google Workspace, Stripe, and barcode tools to <br></br>automate fire inspection workflows, reporting, and invoicing.</p>
            <Link to="#">
               <button>Get Started <ArrowForward style={{ marginLeft: '8px', verticalAlign: 'middle' }} /></button>
            </Link>
            </div>
            <MainbussinessImage>

            </MainbussinessImage>
          </Business>

        <PricePlans hdrTxt="Affordable Fire Protection Software Plans for " subhdrTxt="Contractors, Teams & Fleets" innerTxt="Choose a plan that fits your Fire Protection business and get powerful features without the hefty price tag."></PricePlans>




          

          <InsightSection>
             
            <h2><span>Insights & Tips </span>for Fire Safety Pros</h2>
            <p>Power up your business with bite-sized tips, tools, and strategies, whether you're in the office or out in the field.</p>
              <Ineerinsightbox>
                {Insightdata.map((item, index) => (
                <div key={index} style={{ width: '30%', background: '#fff', borderRadius: '8px', }}>
                  <img src={item.InsightImage} alt={item.Insighttitle} style={{ width: '100%', borderRadius: '6px' }} />
                  <h3 style={{ marginTop: '1rem' }}>{item.Insighttitle}</h3>
                  <p>{item.Insightdesc}</p>
                  <small>{item.Insightdate}</small>
                </div>
              ))}
              </Ineerinsightbox>

              <Mobilebox>
               <Slider {...settings}>
                  {Insightdata.map((item, index) => (
                    <div key={index}>
                      <div
                        style={{
                          width: '90%',
                          margin: '0 auto',
                          background: '#fff',
                          padding: '0rem',
                          borderRadius: '8px',
                        }}
                      >
                        <img
                          src={item.InsightImage}
                          alt={item.Insighttitle}
                          style={{ width: '100%', borderRadius: '6px' }}
                        />
                        <h3 style={{ marginTop: '1rem' }}>{item.Insighttitle}</h3>
                        <p>{item.Insightdesc}</p>
                        <small>{item.Insightdate}</small>
                      </div>
                    </div>
                  ))}
                </Slider>

              </Mobilebox>

          </InsightSection>
          
          <FAQsection>
            <h2>Frequently Asked <span>Questions</span></h2>
            <p>Got questions? We’ve got answers. Here’s everything you need to know about how ServTrackr helps electricians, contractors, and field techs work smarter.</p>
            <Link to="#">
               <button>Contact Us <ArrowForward style={{ marginLeft: '8px', verticalAlign: 'middle' }} /></button>
            </Link>
              <FaqItem>
            {footerfaqs.map((item, index) => {
                const isActive = activeIndex === index;
                return (
                  <AccordionItems key={index}>
                    <Question
                      onClick={() => toggleAccordion(index)}
                      style={{
                        backgroundColor: isActive ? '#fff' : 'transparent',
                        color: isActive ? '#000' : '#000',
                        padding: '1rem',
                        borderRadius: '8px 8px 0 0',
                        cursor: 'pointer',
                        marginBottom: '10px',
                        transition: 'all 0.3s ease',
                        margin: '0px',
                        fontSize: '20px',
                        fontFamily: 'BlinkMacSystemFont, sans-serif !important',
                        fontWeight: '600',
                      }}
                    >
                      {item.question}
                      <span style={{ float: 'right' }}>{isActive ? '-' : '+'}</span>
                    </Question>

                    {isActive && (
                      <Answer
                        dangerouslySetInnerHTML={{ __html: item.answer }}
                        style={{
                          backgroundColor: '#fff',
                          padding: '0 30px 30px 30px',
                          borderRadius: '0 0 8px 8px',
                          color: '#000',
                          fontSize: '15px',
                          margin: '0px',
                        }}
                      />
                    )}
                  </AccordionItems>
                );
              })}
          </FaqItem>

          </FAQsection>

        <Topfooter>
        <FooterMaincontainer>
          <div class="top-footer">
            <div class="frst-lftsc">
              <h2>Smarter Fire Protection Starts with ServTrackr</h2>
              </div>
              <div class="frst-rightsc">
              <p>Track service schedules and customer data while keeping<br></br> your fire protection services on point with ServTrackr.</p>
              <div class="service-btn">
                <Link to="#">
                  <button>Start Free Trial <ArrowForward style={{ marginLeft: '8px', verticalAlign: 'middle' }} /></button>
              </Link>
              <Link to="#">
                  <button class="secondary-button">Book a Demo </button>
              </Link>

              </div>
              </div>
              </div>
          </FooterMaincontainer>
          </Topfooter>


    </PageContainer>
  );
  
};

export default FireProtection
